// Reglas puras de "qué puede hacer una org" segun su plan. Sin React ni red.
export const STARTER_DEFAULTS = {
  limits: { players_max: 30, groups_max: 2, staff_max: 3, deportes_max: 1, audit_log_days: 0 },
  features: {
    programs: false, categories_custom: false, branding_custom: false,
    payments_module: false, uniforms_module: false, inventory_module: false,
    cross_org_inscription: false,
    audit_log_visible: false, export_excel: false, export_pdf: false,
  },
}

const RESOURCE_TO_LIMIT_KEY = {
  players: 'players_max', groups: 'groups_max', staff: 'staff_max', deportes: 'deportes_max',
}

// Plan de menor tier que incluye cada feature (para el copy del upsell).
export const FEATURE_REQUIRED_PLAN = {
  programs: 'Club', categories_custom: 'Club', branding_custom: 'Club',
  payments_module: 'Club', cross_org_inscription: 'Club', audit_log_visible: 'Club',
  export_excel: 'Club', uniforms_module: 'Pro', export_pdf: 'Pro',
  inventory_module: 'Pro',
}

export const computeEntitlements = ({ subscription, usage, isPlatformAdmin } = {}) => {
  const used = usage || {}
  const bypass = !!isPlatformAdmin || !!subscription?.grandfathered_forever
  const isReadOnly = subscription?.status === 'read_only' || subscription?.status === 'paused'
  const limits = subscription?.plan?.limits || STARTER_DEFAULTS.limits
  const features = subscription?.plan?.features || STARTER_DEFAULTS.features
  const planName = subscription?.plan?.name || 'Starter'

  const hasModule = (key) => (bypass ? true : features?.[key] === true)

  const can = (resource) => {
    if (bypass) return true
    if (isReadOnly) return false
    const key = RESOURCE_TO_LIMIT_KEY[resource]
    const limit = key ? limits?.[key] : undefined
    if (limit === undefined || limit === null) return false
    return (used[resource] ?? 0) < limit
  }

  const remaining = (resource) => {
    if (bypass) return Infinity
    const key = RESOURCE_TO_LIMIT_KEY[resource]
    const limit = key ? limits?.[key] : undefined
    if (limit === undefined || limit === null) return 0
    return Math.max(0, limit - (used[resource] ?? 0))
  }

  return { isUnlimited: bypass, isReadOnly, limits, features, usage: used, planName, hasModule, can, remaining }
}
